import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    fromDate: '',
    toDate: '',
    tipoDE: {}
};
export const reporteReducer = createSlice({
    name: 'reporte',
    initialState: initialState,
    reducers: {
        updateFromDate: (state, action) => {
            state.fromDate = action.payload.fromDate;
        },
        updateToDate: (state, action) => {
            state.toDate = action.payload.toDate;
        },
        updateTipoDE: (state, action) => {
            state.tipoDE = action.payload.tipoDE;
        },
        clearReportsState: (state) => {
            return { ...initialState };
        }
    }
});

export const { clearReportsState, updateToDate, updateFromDate, updateTipoDE } = reporteReducer.actions;
